import Validation from "@/validation/Validation";

class UserValidation extends Validation {
    static getCustomErrorMessages() {
        return {
            custom: {
                // General Details
                Title: {
                    required: 'The Title Name is required',
                },
                FirstName: {
                    required: 'The First Name is required',
                },
                LastName: {
                    required: 'The Last Name field is required',
                },
                EmailAddress: {
                    required: 'The Username field is required',
                    email: 'The Username field must be a valid email',
                },
                // Address
                AddressType: {
                    required: 'The Address Type field is required'
                },
                AddressLine1: {
                    required: 'The Address Line 1 field is required'
                },
                City: {
                    required: 'The City field is required'
                },
                PostalCode: {
                    required: 'The Postal Code field is required'
                },
                Country: {
                    required: 'The Country field is required'
                },
            }
        }
    }
}

export default UserValidation;
